import { combineReducers } from "@reduxjs/toolkit";
import stateSlice from "./statesSlice";

export const stateReducer = combineReducers({
  states: stateSlice
})